import { EnvTag } from "../Tag/Tag";
import { ProductSelector } from "../ProductSelector/ProductSelector";
import { UserDropdown } from "../ProductSelector/UserDropdown/UserDropdown";
import { OrganizationLogo, OrganizationName } from "./_components/Organization.component";
import { NavigationMenuWrapper as NavigationMenu } from "./_components/Navigation.component";
import * as HamburgerMenu from "./_components/HamburgerMenu.component";
export const TopBarContent = Object.assign({ EnvTag,
    OrganizationName,
    OrganizationLogo,
    NavigationMenu,
    ProductSelector,
    UserDropdown }, HamburgerMenu);
